import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  FilterPreset,
  SearchFilterScope,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.search}search/filter/currentUser`;

async function currentUserFiltersQuery({
  scope,
  tenantId,
}: {
  tenantId: string;
  scope: SearchFilterScope;
}): Promise<BackResponse<FilterPreset[]> | BackResponseFailure> {
  try {
    const response = await apiCall<BackResponse<FilterPreset[]>>(
      buildUrl(ENDPOINT, { scope, tenantId }),
      {
        method: SUPPORTED_METHODS.GET,
      },
    );

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default currentUserFiltersQuery;
